module.exports = __webpack_public_path__ + "static/media/weglot-translate.3e03f8ad.png";